// src/constant/spotsiteData.js
export const branches = [
  {
    slug: 'junggu-jihwal',
    name: '서울중구지역자활센터',
    url: 'https://www.happyworks21.kr/',
    summary: '중구 내 취약계층의 자립·자활을 지원하는 지역자활센터.',
    description: `서울중구지역자활센터는 보건복지부로부터 지정받아
      에스이임파워 사회적협동조합이 운영하는 전문 사회복지 기관입니다.
      
      저소득층 주민들의 자립과 자활을 지원하며,
      일자리 제공과 정서적·사회적 역량 강화를 통해
      지속 가능한 자활기회를 만들어가고 있습니다.
      
      '생산, 협동, 나눔'의 가치를 바탕으로
      지역사회와 함께 성장하는 자활공동체를 지향합니다.`,
  },
  {
    slug: 'nowon-nambu-jihwal',
    name: '서울노원남부지역자활센터',
    url: 'http://www.snnj.kr/',
    summary: '노원구 남부권 대상 자활·자립 프로그램 운영.',
    description: `서울노원남부지역자활센터는 보건복지부로부터 지정받아
      에스이임파워 사회적협동조합이 운영하는 전문 사회복지 기관입니다.
      
      저소득층 주민들의 자립과 자활을 지원하며,
      일자리 제공과 정서적·사회적 역량 강화를 통해
      지속 가능한 자활기회를 만들어가고 있습니다.
      
      '생산, 협동, 나눔'의 가치를 바탕으로
      지역사회와 함께 성장하는 자활공동체를 지향합니다.`,
  },
  {
    slug: 'junggu-care',
    name: '중구행복돌봄센터',
    url: 'https://xn--2e0by4j8qi0bt02giur.kr/',
    summary: '중구 지역 어르신·돌봄 대상의 종합 돌봄 서비스 제공.',
    description: `중구행복돌봄센터는 에스이임파워 사회적협동조합이 운영하는 돌봄 특화 사회서비스 기관입니다.
    
    가사간병방문지원사업, 장애인, 어르신, 돌봄이 필요한 지역 주민들을 위한
    다양한 돌봄 사회서비스를 제공해 왔습니다.
    
    장애인활동지원사업, 가사간병방문지원사업, 재가장기요양(방문요양), 돌봄SOS 등
    전문 돌봄 인력이 지역 내 돌봄이 필요한 이웃들에게
    실질적인 지원과 정서적 안정, 삶의 질 향상을 위한 서비스를 제공하고 있습니다.`,
  },
  {
    slug: 'nowon-care',
    name: '노원행복돌봄센터',
    url: null,
    summary: '노원구 지역 중심의 일상 돌봄 지원(공식 사이트 준비 중).',
    description: `노원행복돌봄센터는 에스이임파워 사회적협동조합이 운영하는 돌봄 특화 사회서비스 기관입니다.
    
    가사간병방문지원사업, 장애인, 어르신, 돌봄이 필요한 지역 주민들을 위한
    다양한 돌봄 사회서비스를 제공해 왔습니다.
    
    장애인활동지원사업, 가사간병방문지원사업, 돌봄SOS, 노인맞춤돌봄사업 등
    전문 돌봄 인력이 지역 내 돌봄이 필요한 이웃들에게
    실질적인 지원과 정서적 안정, 삶의 질 향상을 위한 서비스를 제공하고 있습니다.`,
  },
];
